// extracted by mini-css-extract-plugin
export var banner = "_sn-0";
export var settingRow = "_sn-2";
export var titleIcon = "_sn-1";